import DrawerButton from "components/form/DrawerButton";
import Error from "components/form/Error";
import LabelArea from "components/form/LabelArea";
import AlertBox from "components/form/AlertBox";
import Title from "components/form/Title";
import useAirportPickupPeriodicHikeTimeSubmit from "hooks/useAirportPickupPeriodicHikeTimeSubmit";
import DynamicAirportPeriodicHikeTimeInput from "components/form/DynamicAirportPeriodicHikeTimeInput";
import SelectPeriodicAirport from "components/form/SelectPeriodicAirport";
import React from "react";
import Scrollbars from "react-custom-scrollbars-2";
// import DateRangePicker from "components/form/InputDateRangePicker";

const AirportPickupPeriodicHikeTimeDrawer = ({ id }) => {
  const {
    handleVehicleCategoryChange,
    setDataInput,
    dataInput,
    handleChangeInput,
    register,
    handleSubmit,
    selectedCity,
    onSubmit,
    handleCityChange,
    handleStartTimeChange,
    handleEndTimeChange,
    trigger,
    errors,
    startTimeOptions,
    setOpen,
    open,
    loading,
  } = useAirportPickupPeriodicHikeTimeSubmit(id);

  return (
    <>
      <AlertBox
        setOpen={setOpen}
        open={open}
        errmsg={"Error: Same time should not allow"}
      />
      <div className="w-full relative p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
        {id ? (
          <Title
            title={"Edit Airport Pickup Periodic Hike Time"}
            description={""}
          />
        ) : (
          <Title
            title={"Add Airport Pickup Periodic Hike Time"}
            description={""}
          />
        )}
      </div>
      <Scrollbars className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative dark:bg-gray-700 dark:text-gray-200">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="px-6 pt-8 flex-grow scrollbar-hide w-full max-h-full pb-40">
            <div className="grid grid-cols-8 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <div className="col-span-6 sm:col-span-4">
                <LabelArea label={"Name of the Airport"} />
                <SelectPeriodicAirport
                  register={register}
                  label="Name of the Airport"
                  name="name_of_aiport"
                  type="text"
                  placeholder={"--Choose--"}
                  selectedCity={selectedCity}
                  handleCityChange={handleCityChange}
               
                />
                <Error errorName={errors.name_of_aiport} />
              </div>
            </div>

            <DynamicAirportPeriodicHikeTimeInput
              register={register}
              trigger={trigger}
              errors={errors}
              dataInput={dataInput}
              setDataInput={setDataInput}
              handleChange={handleChangeInput}
              handleVehicleCategoryChange={handleVehicleCategoryChange}
              handleStartTimeChange={handleStartTimeChange}
              handleEndTimeChange={handleEndTimeChange}
              StartTimeOptions={startTimeOptions}
            />
          </div>

          <DrawerButton
            isSubmitting={loading}
            id={id}
            title={id ? "Update" : "Submit"}
          />
        </form>
      </Scrollbars>
    </>
  );
};

export default AirportPickupPeriodicHikeTimeDrawer;
